import NavIcon from "./NavIcon";

export default function HeartbeatIcon(props) {
  return (
    <NavIcon {...props}>
      <path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0l-.77.78-.77-.78a5.4 5.4 0 0 0-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z" />
      <path d="M3.5 12h3l2-3 2 6 2-3h3" />
    </NavIcon>
  );
}
